import React, { useState } from 'react'
import { Table, Row, Col, Button, Input, Select } from 'antd'
import ModalNewPending from './ModalNewPendings';

import { saveEditPendings } from '../../helpers/meetings/saveEditPendings';
import { deletePending } from '../../helpers/meetings/deletePending';

const Pendings = ({ quarterly, meetingDate, setLoadDataPending, pendings, pendingsEdit, setPendingsEdit, users, setShowAlertPendings, setOptionAlert }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const editPending = (value, record) => {
        const updatedPendings = pendings
            .filter(pending => pending.id === record.id)
            .map(pending => ({ ...pending, status: value }));

        setPendingsEdit(prev =>
            [
                ...prev.filter(p => p.id !== record.id),
                ...updatedPendings
            ]
        );
    }

    const handleEditPendings = () => {
        saveEditPendings(pendingsEdit).then((response) => {
            if (response.status === "success") {
                setShowAlertPendings(true);
                setOptionAlert({
                    message: "Pendientes actualizados",
                    description: "Los pendientes se han actualizado correctamente.",
                    type: "success"
                });
                setPendingsEdit([]);
                setLoadDataPending(true);
            }
        });
    }

    const handleDeletePending = id => {
        deletePending(id).then((response) => {
            if (response.status === "success") {
                setShowAlertPendings(true);
                setOptionAlert({
                    message: "Pendiente eliminado",
                    description: "El pendiente se ha eliminado correctamente.",
                    type: "success"
                });
                setLoadDataPending(true);
            }
        });
    }

    const columnsPending = [
        {
            title: 'Fecha',
            dataIndex: 'meeting_date',
            key: 'meeting_date',
            width: 100,
            render: (_, record) => {
                return <p>{record.meeting_date}</p>;
                // return <Input value={record.meeting_date} disabled={true} />;
            }
        },
        {
            title: 'Responsable',
            dataIndex: 'username',
            key: 'username',
            width: 200,
            render: (_, record) => {
                return <p>{record.username}</p>;
                // return <Input value={record.username} disabled={true} />;
            }
        },
        {
            title: 'Descripción',
            dataIndex: 'description',
            key: 'description',
            render: (_, record) => {
                return <p>{record.description}</p>;
                // return <Input value={record.description} disabled={true} />;
            }
        },
        {
            title: 'Estado',
            dataIndex: 'status',
            key: 'status',
            width: 100,
            render: (_, record) => {
                return <Select
                    options={[
                        { value: 'En proceso', label: 'En proceso' },
                        { value: 'Realizado', label: 'Realizado' },
                        { value: 'No realizado', label: 'No realizado' },
                    ]}
                    allowClear
                    defaultValue={record.status}
                    style={{ width: '100%' }}
                    onChange={(value) => editPending(value, record)}
                />
            }
        },
        {
            title: 'Acciones',
            dataIndex: 'actions',
            key: 'actions',
            width: 100,
            render: (_, record) => {
                return <Button type="link" onClick={() => handleDeletePending(record.id)}>Eliminar</Button>;
            }
        },
    ];

    return (
        <div style={{ margin: "0 12px" }}>
            <Row gutter={16} style={{ marginBottom: "12px" }}>
                <Col span={18}>
                    <h3 style={{ fontSize: "18px", margin: 0 }}>Lista de pendientes | Grupo Optima</h3>
                    <p style={{ fontSize: "16px", margin: 0, color: "gray" }}>Seguimiento de Tareas y Compromisos</p>
                </Col>
                <Col span={3}>
                    <Button type="primary" style={{ float: "right", marginBottom: "12px" }} onClick={showModal}>Agregar Pendiente</Button>
                </Col>
                <Col span={3} style={{ textAlign: "right" }}>
                    <Button type="primary" style={{ backgroundColor: '#00A310', border: 'none' }} onClick={handleEditPendings}>Guarda pendientes</Button>
                </Col>
            </Row>


            <Row>
                <Col span={24}>
                    <Table dataSource={pendings} columns={columnsPending} />
                </Col>
            </Row>

            <ModalNewPending
                isModalOpen={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                quarterly={quarterly}
                meetingDate={meetingDate}
                setLoadDataPending={setLoadDataPending}
                users={users}
            />
        </div>
    )
}

export default Pendings